<template>
  <div class="ModuleTitle">
    <div class="ModuleTitle_box">
      <div class="ModuleTitle_img">
        <div v-if="language == 'zh'">
          <img :src="src" alt />
        </div>
        <div
          v-else

          class="tit enfamily"
          :style="{ color: ModuleTitle.color ? ModuleTitle.color : '' }"
        >
        <!-- {{ModuleTitle}} -->
          {{ ModuleTitle.zhTitle }}
        </div>
      </div>
      <div
        @click="toMore(ModuleTitle.name)"
        class="more enfamily"
        v-show="ModuleTitle.more"
        :style="{ color: ModuleTitle.color ? ModuleTitle.color : '' }"
      >
        {{ $t("PublicComponents.ModuleTitle.More") }}>
      </div>
    </div>

    <div class="bottom_line" :class="[ModuleTitle.name != 'Technology'?'noHr':'']"></div>
  </div>
</template>

<script>
import { mapMixin } from "@/util/mixin";
export default {
  mixins: [mapMixin],
  props: ["ModuleTitle"],
  mounted() {
    this.src = this[this.ModuleTitle.name];
  },
  data() {
    return {
      src: "",
      Society: require("../../../assets/image/Index/Society.png"), //社会
      Technology: require("../../../assets/image/Index/Technology.png"), //科技
      Case: require("../../../assets/image/Index/case.png"), //实践案例
      knowledge: require("../../../assets/image/Index/knowledge.png"), //知识库
    };
  },
  methods: {
    toMore(query) {
      this.$router.push(`/newslist?type=${query}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1026px) {
    .enfamilytitle{
 font-family: $enfamilytitle;
  }
    .enfamily{
 font-family: $enFamily;
  }
  .ModuleTitle {
    margin-top: 40px;
    .ModuleTitle_box {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .ModuleTitle_img {
        // padding: 4px 0;
        height: 40px;
        margin-right: 10px;
        .tit {
          font-weight: 600;
          // font-family: "arail";
          font-size: 32px;
        }
        img {
          // width: 160px;
          height: 40px;
        }
      }
      .more:hover {
        // font-size: 16px;
        text-decoration: none;
        transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
        background-size: 100% 2px;
        cursor: pointer;
      }
      .more {
        height: 22px;
        background-image: linear-gradient(#999, #999);
        background-position: center bottom;
        background-repeat: no-repeat;
        transition: background-size 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);
        text-decoration: none;
        background-size: 0 2px;
      }
    }
  }
  .noHr{
      background: transparent;
  }
  .bottom_line {
    width: 1200px;
    height: 2px;
    opacity: 0.5;
    background: #cbcbcb;
    // border: 2px solid #cbcbcb;
    margin: 20px auto;
  }
}
@media screen and (min-width: 768px) and (max-width: 1025px) {
  .ModuleTitle {
    margin-top: 40px;
    .ModuleTitle_box {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .ModuleTitle_img {
        padding: 4px 0;
        height: 40px;
        margin-right: 10px;
        img {
          width: 140px;
          // height: 100%;
        }
      }
      .more:hover {
        // font-size: 16px;
        text-decoration: none;
        transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
        background-size: 100% 2px;
        cursor: pointer;
      }
      .more {
        height: 22px;
        background-image: linear-gradient(#999, #999);
        background-position: center bottom;
        background-repeat: no-repeat;
        transition: background-size 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);
        text-decoration: none;
        background-size: 0 2px;
      }
    }
  }

  .bottom_line {
    width: 1200px;
    height: 2px;
    opacity: 0.5;
    background: #cbcbcb;
    // border: 2px solid #cbcbcb;
    margin: 20px auto;
  }
}
@media screen and (max-width: 767px) {
  .ModuleTitle {
    margin-top: 14px;
    .ModuleTitle_box {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .ModuleTitle_img {
        padding: 4px 0;
        height: 30px;
        margin-right: 10px;
        font-weight: 600;
        .tit{
          font-size: 20px;
          font-weight: 600;
        }
        img {
                  width: 140px;
          height: 100%;
        }
      }

      .more {
        height: 22px;
        background-image: linear-gradient(#999, #999);
        background-position: center bottom;
        background-repeat: no-repeat;
        transition: background-size 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);
        text-decoration: none;
        background-size: 0 2px;
      }
    }
  }

  .bottom_line {
    width: 1200px;
    height: 2px;
    opacity: 0.5;
    background: #cbcbcb;
    // border: 2px solid #cbcbcb;
    margin: 20px auto;
  }
}
</style>